
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { calendarComponent } from './calendar.component';
import { FormsModule } from '@angular/forms';
import { DossierHeaderModule } from '../dossiers/components/dossierHeader.module';
import { TranslateModule } from '@ngx-translate/core';
import { FullCalendarModule } from 'primeng-lts/fullcalendar';
import { CalendarEventComponent } from './calendarEvent.component';
import { SubHeaderModule } from '../components/common/sub-header/sub-header.module';
import { FormPlycaModule } from '../components/forms/formPlyca.module';
import { CalendarModule } from 'primeng-lts/calendar';
import { CheckboxModule } from 'primeng-lts/checkbox';
import { DialogModule } from 'primeng-lts/dialog';
import { PanelModule } from 'primeng-lts/panel';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';
import { WaitLoadingModule } from '../components/common/waitLoading/waitLoading.module';
import { DynamicDialogModule } from 'primeng-lts/dynamicdialog';

@NgModule({
  declarations: [CalendarEventComponent, calendarComponent],
  imports: [
    TranslateModule,
    CommonModule,
    FormsModule,
    DossierHeaderModule,
    DialogModule,
    DynamicDialogModule,
    CalendarModule,
    FullCalendarModule,
    CheckboxModule,
    PanelModule,
    ScrollPanelModule,
    SubHeaderModule,
    FormPlycaModule,
    ScrollPanelModule,
    WaitLoadingModule
  ]

})
export class CalendModule { }
